"use client";
import {
  link_default
} from "../../chunk-G2RWOC5I.js";
export {
  link_default as default
};
